/* @flow */

import type { NETGEM_API_V8_HUB } from '../../../../libs/netgemLibrary/v8/types/Hub';
import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { RequestResponseMethodDefinitionType } from '../emitter';

import { createCustomNetworkErrorFromKey } from '../../../../libs/netgemLibrary/helpers/CreateCustomNetworkError';
import { getSettingValueByName } from '../helpers/settings';
import { sendV8HubRequest } from './hub';

const search: (signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers): Promise<NETGEM_API_V8_HUB> => {
    const { appConfiguration } = getState();
    const key = getSettingValueByName('platform.hubkeys', 'search', appConfiguration);

    if (!key) {
      return Promise.reject(createCustomNetworkErrorFromKey('common.messages.errors.missing_search_key'));
    }

    return dispatch(sendV8HubRequest(key, signal));
  };

export default search;
